export const animateDef = [
    [
        {
            x: 0,
            y: 13,
            height: 53
        },
        {
            x: 16,
            y: 0,
            height: 79
        },
        {
            x: 32,
            y: 9,
            height: 61
        },
        {
            x: 48,
            y: 18,
            height: 43
        },
        {
            x: 64,
            y: 28,
            height: 23
        }
    ],
    [
        {
            x: 0,
            y: 37,
            height: 5
        },
        {
            x: 16,
            y: 37,
            height: 5
        },
        {
            x: 32,
            y: 37,
            height: 5
        },
        {
            x: 48,
            y: 37,
            height: 5
        },
        {
            x: 64,
            y: 37,
            height: 5
        }
    ],
    [
        {
            x: 0,
            y: 33,
            height: 13
        },
        {
            x: 16,
            y: 23,
            height: 33
        },
        {
            x: 32,
            y: 28,
            height: 23
        },
        {
            x: 48,
            y: 9,
            height: 61
        },
        {
            x: 64,
            y: 14,
            height: 51
        }
    ],
    [
        {
            x: 0,
            y: 0,
            height: 79
        },
        {
            x: 16,
            y: 23,
            height: 33
        },
        {
            x: 32,
            y: 15,
            height: 49
        },
        {
            x: 48,
            y: 29,
            height: 21
        },
        {
            x: 64,
            y: 34,
            height: 11
        }
    ],
    [
        {
            x: 0,
            y: 24,
            height: 31
        },
        {
            x: 16,
            y: 33,
            height: 13
        },
        {
            x: 32,
            y: 13,
            height: 53
        },
        {
            x: 48,
            y: 24,
            height: 31
        },
        {
            x: 64,
            y: 3,
            height: 73
        }
    ],
    [
        {
            x: 0,
            y: 25,
            height: 29
        },
        {
            x: 16,
            y: 14,
            height: 51
        },
        {
            x: 32,
            y: 32,
            height: 15
        },
        {
            x: 48,
            y: 21,
            height: 37
        },
        {
            x: 64,
            y: 25,
            height: 29
        }
    ]
]
